// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3uNny","label":"Section_label__X2Mo2","contentWrap":"Section_contentWrap__3aIpL","footer":"Section_footer__239Un","footerInner":"Section_footerInner__2Rwrv"};